// extracted by mini-css-extract-plugin
export default {"badge":"LockedFeatureBadge_badge__m7JzI","icon":"LockedFeatureBadge_icon__uGfwv"};